module.exports = __webpack_public_path__ + "media/drums.a17b044d.mp4";